import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream-100 px-4 py-20" data-id="element-161" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-162" data-mp="3fz5oy0b7bohu">
        <div className="text-center" data-id="element-163" data-mp="3fy30s059k05m">
          <h2 className="font-display text-[26px] font-black leading-tight text-ink sm:text-[32px]" data-id="element-164" data-mp="3b0kmrvce2uqr">
            Cosa dicono i docenti
          </h2>
          <p className="mt-3 font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-165" data-mp="36zqz932uzhye">
            Oltre 1.500 insegnanti lo usano ogni settimana
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-166" data-mp="2x1uq2gthex2x">
          {testimonials.map(t => <li key={t.name} className="flex h-full flex-col rounded-2xl border border-cream-300 bg-cream-200/70 p-6" data-id="element-167" data-mp="2s2rv5p77u78o">
              <div className="flex gap-0.5" aria-label="Valutazione 5 stelle su 5" data-id="element-168" data-mp="qac1axrhk6zc">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-brand text-brand" aria-hidden="true" data-id="element-169" data-mp="h559bys2ppvi" data-mpi={i} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[13px] leading-relaxed text-ink-soft" data-id="element-170" data-mp="79lfdhx2l19e">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <div className="mt-auto pt-6" data-id="element-171" data-mp="zw68onx3vnfl">
                <p className="font-display text-[14px] font-bold text-ink" data-id="element-172" data-mp="zyiw3glmuq01">{t.name}</p>
                <p className="mt-0.5 font-sans text-[11px] text-ink-muted" data-id="element-173" data-mp="14ur6kgovxv0v">{t.role}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}